export const styles = {
  cardContainer: {
    marginBottom: "1.6rem",
    padding: "1.2rem 0.8rem",
    borderRadius: "0.8rem",
    background: "var(--neutral-100)",
    backgroundColor: "var(--neutral-100)",
  },
  borderLine: {
    marginTop: "0.8rem",
    borderTop: "0.1rem solid var(--gray-20)",
  },
  videoTimeDetail: {
    display: "flex",
    alignItems: "center",
    gap: "0.2rem",
    marginTop: "0.6rem",
    color: "var(--gray-500)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
  openChat: {
    margin: "0.8rem 0rem",
    display: "flex",
    gap: "0.6rem",
    width: "100%",
  },
  mapText: {
    color: "var(--orange-500)",
    fontSize: "1.2rem",
    fontWeight: 500,
    cursor: "pointer",
  },
  hideShowBlock: {
    display: {
      xs: "none",
      md: "block",
    },
  },
  clinicInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.8rem",
  },
  clinicLocation: {
    display: "flex",
    alignItems: "center",
    gap: "0.8rem",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.8rem",
    width: "100%",
    mt: "0.8rem",
  },
  contactSupportButton: {
    display: { xs: "flex", md: "none" },
  },
  chatButton: {
    display: "flex",
  },
  contactSupportOrChatButton: (isButtonDisabled: boolean) => ({
    display: { xs: "flex", md: "none" },
    alignItems: "center",
    justifyContent: "center",
    width: "10.8rem",
    height: "4.8rem",
    padding: "0.6rem 0rem",
    gap: "0.8rem",
    background: isButtonDisabled ? "var(--gray-300)" : "var(--orange-500)",
    borderRadius: "1.8rem",
    cursor: isButtonDisabled ? "not-allowed" : "pointer",
  }),
  responsiveCardContainer: {
    "@media screen and (max-width: 65rem)": {
      padding: "1.2rem",
    },
  },
};
